module.exports = __webpack_public_path__ + "img/icon-exit.16be05b4.svg";